export default __webpack_public_path__ + "static/media/project6.711ba354.jpg";